import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Helmet } from "react-helmet";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import SidebarMenu from "./components/SidebarMenu";
import "./index.css";
import OfferSlider from "./OfferSlider";

const Header = () => {
  const [isCart, setIsCart] = useState(false);
  const [isCheckout, setIsCheckout] = useState(false);
  const [isProductDetails, setIsProductDetails] = useState(false);
  const [isCategory, setIsCategory] = useState(false);
  const [isPayment, setIsPayment] = useState(false);
  const [isWhishList, setIsWhishList] = useState(false);
  const [thankYou, setThankYou] = useState(false);
  const [orderComfirm, setOrderComfirm] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  let location = useLocation();
  const navigate = useNavigate();
  const {
    step,
    cartProducts,
    singleProduct,
    isPaymentPageLoading,
    setIsPaymentPageLoading,
    whiteListProducts,
  } = useAuth();

  useEffect(() => {
    setIsCart(location.pathname.indexOf("/cart") > -1);
    setIsCheckout(location.pathname.indexOf("/checkout/address") > -1);
    // setIsPayment(location.pathname.indexOf("/checkout/payment") > -1);
    setIsProductDetails(location.pathname.indexOf("/single-product") > -1);
    setIsCategory(location.pathname.indexOf("/category") > -1);
    setIsWhishList(location.pathname.indexOf("/wishlist") > -1);
    setThankYou(location.pathname.indexOf("/thankyou") > -1);
    setOrderComfirm(location.pathname.indexOf("/order-comfirmation") > -1);
  }, [location]);

  useEffect(() => {
    if (cartProducts.length > 0) {
      let timecout = 0;
      let notification = document.getElementById("notificationCount");

      notification?.classList?.add("bounceNotification");
      timecout = setTimeout(() => {
        notification = document.getElementById("notificationCount");
        if (notification?.classList?.contains("bounceNotification")) {
          notification?.classList?.remove("bounceNotification");
          timecout = 0;
        }
      }, 5000);
    }
  }, [cartProducts]);

  //  Mini component for menu toggle icon
  const MenuToggle = ({ color }) => (
    <div
      className="icon-box"
      onClick={() => setShowSidebar((v) => !v)}
      style={{ cursor: "pointer" }}
      aria-label={showSidebar ? "Close menu" : "Open menu"}
    >
      <i
        className={`fa-solid ${showSidebar ? "fa-xmark" : "fa-bars"}`}
        style={{ color }}
      ></i>
    </div>
  );
  let navThemeColor = process.env.REACT_APP_NAV_THEME_COLOR;
  const logo = process.env.REACT_APP_LOGO;

  // Auto light/dark detector (Hex → RGB → luminance)
  const getLuminance = (hex) => {
    if (!hex) return 0;
    hex = hex.replace("#", "");
    if (hex.length === 3)
      hex = hex
        .split("")
        .map((x) => x + x)
        .join("");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  };
  const iconColor = getLuminance(navThemeColor) > 0.7 ? "#000" : "#fff";

  const theme = process.env.REACT_APP_NAV_THEME_COLOR || "#000";

  const isLightColor = (hex = "") => {
    let h = hex.trim().toLowerCase();
    if (!h.startsWith("#")) return false;
    if (h.length === 4) h = "#" + [...h.slice(1)].map((c) => c + c).join("");
    const r = parseInt(h.slice(1, 3), 16);
    const g = parseInt(h.slice(3, 5), 16);
    const b = parseInt(h.slice(5, 7), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.8;
  };

  useEffect(() => {
    if (isLightColor(theme)) {
      document.body.classList.add("light-nav");
    } else {
      document.body.classList.remove("light-nav");
    }
  }, [theme]);
  const wishlistCount = whiteListProducts?.length || 0;

  return (
    <>
      <Navbar
        expand="lg"
        sticky="top"
        className={`flex-column  custom-navbar ${
          isProductDetails && singleProduct?._id ? "pb-0" : ""
        }`}
        id="nav-look"
        style={{ background: navThemeColor }}
      >
        {/* Google g4tag live tracker */}
        {process.env.REACT_APP_G4 && (
          <Helmet>
            <script
              async
              src={`https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_G4}`}
            ></script>
            <script>
              {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments)}
              gtag('js', new Date())
              gtag('config', '${process.env.REACT_APP_G4}');
            `}
            </script>
          </Helmet>
        )}

        {/* Google Globle live tracker */}

        {process.env.REACT_APP_AW && (
          <Helmet>
            <script
              async
              src={`https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_AW}`}
            ></script>
            <script>
              {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments)}
              gtag('js', new Date())
              gtag('config', '${process.env.REACT_APP_AW}');
              gtag('config', '{{fa_google_ids[0]}}', {'allow_enhanced_conversions':true});
            `}
            </script>
          </Helmet>
        )}
        {/* Facebook Pixel  live tracker */}
        {process.env.REACT_APP_FBPIXEL && (
          <Helmet>
            <script>
              {`
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '${process.env.REACT_APP_FBPIXEL}');
  fbq('track', 'PageView');
  ${
    window.location.href.includes("/address")
      ? 'fbq("track", "InitiateCheckout");'
      : ""
  };
  `}
            </script>
          </Helmet>
        )}

        <Helmet>
          <link rel="icon" type="image/x-icon" href={logo} sizes="16x16" />
        </Helmet>

        {process.env.REACT_APP_FBPIXEL && (
          <noscript>
            <img
              height="1"
              alt={window.location.hostname}
              width="1"
              style="display:none"
              src={`https://www.facebook.com/tr?id=${process.env.REACT_APP_FBPIXEL}&ev=PageView&noscript=1`}
            />
          </noscript>
        )}
        {thankYou ? (
          <Container>
            {thankYou ? (
              <Nav className={"d-flex flex-row m-auto align-items-center"}>
                <Navbar.Brand href="/">
                  {/* dynamic logo use this code */}
                  <img
                    src={logo}
                    // height={50}
                    // width={90}
                    alt={window.location.hostname}
                    className="header-logo"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginLeft: "5px",
                      marginRight: "20px",
                    }}
                  />
                </Navbar.Brand>
              </Nav>
            ) : (
              <Nav
                className={"d-flex flex-row align-items-center"}
                style={{ width: isProductDetails || isWhishList ? "40%" : "" }}
              >
                <div
                  onClick={() => {
                    if (isPaymentPageLoading && isPayment) {
                      setIsPaymentPageLoading(false);
                    } else {
                      navigate(-1);
                    }
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height={24}
                    width={24}
                  >
                    <path
                      fill={iconColor}
                      fillRule="evenodd"
                      d="M20.25 11.25H5.555l6.977-6.976a.748.748 0 000-1.056.749.749 0 00-1.056 0L3.262 11.43A.745.745 0 003 12a.745.745 0 00.262.57l8.214 8.212a.75.75 0 001.056 0 .748.748 0 000-1.056L5.555 12.75H20.25a.75.75 0 000-1.5"
                    ></path>
                  </svg>
                </div>

                <Nav className={"d-flex flex-row align-items-center"}>
                  <Navbar.Brand href="/">
                    <img
                      src={logo}
                      // height={35}
                      alt={window.location.hostname}
                      className="header-logo"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginLeft: "5px",
                        marginRight: "20px",
                      }}
                    />
                  </Navbar.Brand>
                </Nav>
              </Nav>
            )}
          </Container>
        ) : (
          <Container>
            {isCart ||
            isCheckout ||
            isPayment ||
            isProductDetails ||
            isCategory ||
            orderComfirm ||
            isWhishList ? (
              <div className="d-flex align-items-center justify-content-between w-100">
                <Nav
                  className="d-flex flex-row align-items-center"
                  style={{
                    width: isProductDetails || isWhishList ? "40%" : "",
                  }}
                >
                  <div
                    onClick={() => {
                      if (isPaymentPageLoading && isPayment) {
                        setIsPaymentPageLoading(false);
                      } else {
                        navigate(-1);
                      }
                    }}
                    aria-label="Go back"
                    style={{ cursor: "pointer" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height={24}
                      width={24}
                    >
                      <path
                        fill={iconColor}
                        fillRule="evenodd"
                        d="M20.25 11.25H5.555l6.977-6.976a.748.748 0 000-1.056.749.749 0 00-1.056 0L3.262 11.43A.745.745 0 003 12a.745.745 0 00.262.57l8.214 8.212a.75.75 0 001.056 0 .748.748 0 000-1.056L5.555 12.75H20.25a.75.75 0 000-1.5"
                      ></path>
                    </svg>
                  </div>

                  <Nav className="d-flex flex-row align-items-center">
                    <Navbar.Brand href="/">
                      <img
                        src={logo}
                        alt={window.location.hostname}
                        className="header-logo"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginLeft: "5px",
                          marginRight: "20px",
                        }}
                      />
                    </Navbar.Brand>
                  </Nav>
                </Nav>

                {/* RIGHT: Cart icon */}
                <Nav className="d-flex flex-row align-items-center ms-auto position-relative">
                  {!orderComfirm && (
                    <>
                      <Nav.Link
                        onClick={() => navigate("/wishlist")}
                        className="nav-menu position-relative icon-box"
                        aria-label="Open wishlist"
                        style={{ marginRight: "8px" }}
                      >
                        {wishlistCount > 0 && (
                          <div
                            id="wishlistCount"
                            className="animated"
                            style={{
                              position: "absolute",
                              top: "-6px",
                              right: "-6px",
                              borderRadius: "50%",
                              fontWeight: "bold",
                              width: "18px",
                              height: "18px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              background: "red",
                              color: "#fff",
                              fontSize: "12px",
                            }}
                          >
                            {wishlistCount}
                          </div>
                        )}
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                          fill={iconColor}
                          stroke="#fff"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          aria-hidden="true"
                        >
                          <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l1 1L12 22l7.8-8.6 1-1a5.5 5.5 0 0 0 0-7.8z" />
                        </svg>
                      </Nav.Link>

                      <Nav.Link
                        onClick={() => navigate("/cart")}
                        className="nav-menu position-relative icon-box"
                        aria-label="Open cart"
                      >
                        <div
                          id="notificationCount"
                          className="animated"
                          style={{
                            position: "absolute",
                            top: "-6px",
                            right: "-6px",
                            opacity: cartProducts.length > 0 ? 1 : 0,
                            borderRadius: "50%",
                            fontWeight: "bold",
                            width: "18px",
                            height: "18px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "red",
                            color: "#fff",
                            fontSize: "12px",
                          }}
                        >
                          {cartProducts.length}
                        </div>
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          style={{ color: iconColor }}
                        >
                          <circle cx="9" cy="21" r="1"></circle>
                          <circle cx="20" cy="21" r="1"></circle>
                          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                        </svg>
                      </Nav.Link>
                    </>
                  )}
                </Nav>
              </div>
            ) : (
              <Nav className="d-flex flex-row align-items-center justify-content-between w-100">
                <div className="d-flex align-items-center">
                  <Navbar.Brand href="/">
                    <img
                      src={logo}
                      className="header-logo"
                      alt={window.location.hostname}
                      style={{ marginLeft: "10px" }}
                    />
                  </Navbar.Brand>
                </div>

                {/* Center: Navigation Links (Desktop only) */}
                <div className="d-none d-lg-flex gap-5 justify-content-center flex-grow-1 header-links">
                  {[
                    { label: "Home", path: "/" },
                    { label: "Shop", path: "/shop" },
                    { label: "About", path: "/about-us" },
                    { label: "Contact", path: "/contact-us" },
                  ].map((item) => (
                    <Nav.Link
                      key={item.path}
                      onClick={() => navigate(item.path)}
                      className={`fw-semibold nav-link-item ${
                        location.pathname === item.path ? "active" : ""
                      }`}
                      style={{
                        color: iconColor,
                        fontSize: "17px",
                        textTransform: "",
                      }}
                    >
                      {item.label}
                    </Nav.Link>
                  ))}
                </div>

                {/* Right: Cart + Menu */}
                <div className="d-flex align-items-center gap-3 ms-auto">
                  <Nav className="d-flex flex-row align-items-center position-relative">
                    {step && (isCart || isCheckout || isPayment) ? (
                      <>
                        {!orderComfirm && (
                          <>
                            <Nav.Link
                              onClick={() => navigate("/wishlist")}
                              className="nav-menu position-relative icon-box"
                              aria-label="Open wishlist"
                              style={{ marginRight: "8px" }}
                            >
                              {wishlistCount > 0 && (
                                <div
                                  id="wishlistCount"
                                  className="animated"
                                  style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "-6px",
                                    borderRadius: "50%",
                                    fontWeight: "bold",
                                    width: "18px",
                                    height: "18px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    background: "red",
                                    color: "#fff",
                                    fontSize: "12px",
                                  }}
                                >
                                  {wishlistCount}
                                </div>
                              )}
                              <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill={iconColor}
                                stroke="#fff"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                aria-hidden="true"
                              >
                                <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l1 1L12 22l7.8-8.6 1-1a5.5 5.5 0 0 0 0-7.8z" />
                              </svg>
                            </Nav.Link>
                            <Nav.Link
                              onClick={() => navigate("/cart")}
                              className="nav-menu position-relative icon-box"
                            >
                              <div
                                id="notificationCount"
                                className="animated"
                                style={{
                                  position: "absolute",
                                  top: "-6px",
                                  right: "-6px",
                                  opacity: cartProducts.length > 0 ? 1 : 0,
                                  borderRadius: "50%",
                                  fontWeight: "bold",
                                  width: "18px",
                                  height: "18px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  background: "red",
                                  color: "#fff",
                                  fontSize: "12px",
                                }}
                              >
                                {cartProducts.length}
                              </div>

                              <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                // style={{ color: iconColor }}
                              >
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                              </svg>
                            </Nav.Link>

                            <MenuToggle color={iconColor} />
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {!orderComfirm && (
                          <>
                            <Nav.Link
                              onClick={() => navigate("/wishlist")}
                              className="nav-menu position-relative icon-box"
                              aria-label="Open wishlist"
                              style={{ marginRight: "8px" }}
                            >
                              {wishlistCount > 0 && (
                                <div
                                  id="wishlistCount"
                                  className="animated"
                                  style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "-6px",
                                    borderRadius: "50%",
                                    fontWeight: "bold",
                                    width: "18px",
                                    height: "18px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    background: "red",
                                    color: "#fff",
                                    fontSize: "12px",
                                  }}
                                >
                                  {wishlistCount}
                                </div>
                              )}
                              <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill={iconColor}
                                stroke="#fff"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                aria-hidden="true"
                              >
                                <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l1 1L12 22l7.8-8.6 1-1a5.5 5.5 0 0 0 0-7.8z" />
                              </svg>
                            </Nav.Link>
                            <Nav.Link
                              onClick={() => navigate("/cart")}
                              className="nav-menu position-relative icon-box"
                            >
                              <div
                                id="notificationCount"
                                className="animated"
                                style={{
                                  position: "absolute",
                                  top: "-6px",
                                  right: "-6px",
                                  opacity: cartProducts.length > 0 ? 1 : 0,
                                  borderRadius: "50%",
                                  fontWeight: "bold",
                                  width: "18px",
                                  height: "18px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  background: "red",
                                  color: "#fff",
                                  fontSize: "12px",
                                }}
                              >
                                {cartProducts.length}
                              </div>
                              <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{ color: iconColor }}
                              >
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                              </svg>
                            </Nav.Link>
                          </>
                        )}
                        <MenuToggle color={iconColor} />
                      </>
                    )}
                  </Nav>
                </div>
              </Nav>
            )}
          </Container>
        )}
        <Helmet>
          <link rel="icon" href={logo} />
        </Helmet>
        {isProductDetails && singleProduct?._id && (
          <Container
            style={{
              background: "var(--them-color)",
              borderColor: "var(--them-color)",
              fontSize: 20,
              color: "#fff",
              padding: "8px 16px",
              textAlign: "center",
              fontWeight: "600",
            }}
          >
            <div className="m-auto">
              <OfferSlider />
            </div>
          </Container>
        )}
      </Navbar>
      <SidebarMenu
        show={showSidebar}
        handleClose={() => setShowSidebar(false)}
      />

      {step && (isCart || isCheckout) && (
        <div className="main-steps">
          <div
            className="step-container"
            style={
              isCart
                ? {
                    maxWidth: "47%",
                    minWidth: "47%",
                    width: "100%",
                    margin: "auto",
                    position: "absolute",
                    right: "28px",
                  }
                : null
            }
          />
          <div>
            <div
              className="step-number m-auto"
              style={
                step > 1
                  ? { background: "white", border: "1px solid #2874F0" }
                  : { border: "1px solid #2874F0" }
              }
            >
              {step > 1 ? <i className="fa-solid fa-check"></i> : 1}
            </div>
            <p style={{ fontSize: "15px", fontWeight: "500" }}>Cart</p>
          </div>
          <div>
            <div
              className="step-number m-auto"
              style={
                step > 2
                  ? { background: "white", border: "1px solid #2874F0 " }
                  : { border: "1px solid #2874F0 " }
              }
            >
              {step > 2 ? <i className="fa-solid fa-check"></i> : 2}
            </div>
            <p style={{ fontSize: "15px", fontWeight: "500" }}>
              {isCart ? "Order Summary" : "Address"}
            </p>
          </div>
          {/* <div>
                <div
                  className="step-number m-auto"
                  style={
                    step > 3
                      ? { background: "white", border: "1px solid #2874F0 " }
                      : { border: "1px solid #2874F0 " }
                  }
                >
                  {step > 3 ? <i className="fa-solid fa-check"></i> : 3}
                </div>
                <p style={{ fontSize: "15px", fontWeight: "500" }}>Payment</p>
              </div> */}
        </div>
      )}
      {/* {step && (isCart || isCheckout || isPayment) ? (
          <>
            <div style={{ borderTop: "1px solid rgb(206, 206, 222)" }}></div>
          </>

        ) : (
          <></>
        )} */}
    </>
  );
};

export default Header;
